import { createAsyncTypes } from 'store/utils';

// State Key
export const KEY = 'kioskHardware';

// Action Types
export const types = {
  GET_KIOSK_HARDWARE: createAsyncTypes(`${KEY}/GET_KIOSK_HARDWARE`),
  CREATE_KIOSK_HARDWARE: createAsyncTypes(`${KEY}/CREATE_KIOSK_HARDWARE`),
  UPDATE_KIOSK_HARDWARE: createAsyncTypes(`${KEY}/UPDATE_KIOSK_HARDWARE`),
  DELETE_KIOSK_HARDWARE: createAsyncTypes(`${KEY}/DELETE_KIOSK_HARDWARE`),
  RESET_KIOSK_HARDWARE: `${KEY}/RESET_KIOSK_HARDWARE`,
  RESET_ERROR: `${KEY}/RESET_ERROR`,
  RESET_ACTION: `${KEY}/RESET_ACTION`
};

export interface KioskHardwareState {
  readonly kioskHardware: KioskHardware[];
  readonly action: {
    readonly success: boolean;
    readonly pending: boolean;
    readonly error: string | null;
  };
}

type HardwareTypes = 'printer' | 'barcodeScanner' | 'paymentDevice';

export interface KioskHardware {
  id: string;
  kioskId: string;
  hardwareId: string;
  serialCode: string;
  createdAt: string;
  updatedAt: string;
  type: HardwareTypes;
  name: string;
  code: string;
  status: string;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  details: any;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  configuration: any;
  values: {
    currentStock?: number;
  };
}

export interface CreateKioskHardwareRequest {
  type: typeof types.CREATE_KIOSK_HARDWARE.REQUEST;
  payload: CreateKioskHardwarePayload;
}

export interface CreateKioskHardwarePayload {
  kioskId: string;
  hardwareId: string;
  serialCode: string;
  configuration: object;
  values: object;
  status: string;
}

export interface ResetKioskHardware {
  type: typeof types.RESET_KIOSK_HARDWARE;
}

export interface GetKioskHardwareRequest {
  type: typeof types.GET_KIOSK_HARDWARE.REQUEST;
  payload: {
    kioskId: string;
  };
}

export interface GetKioskHardwareError {
  type: typeof types.GET_KIOSK_HARDWARE.ERROR;
  payload: string;
}

export interface GetKioskHardwarePending {
  type: typeof types.GET_KIOSK_HARDWARE.PENDING;
  payload: boolean;
}

export interface GetKioskHardwareSuccess {
  type: typeof types.GET_KIOSK_HARDWARE.SUCCESS;
  payload: KioskHardware[];
}

export type UpdateKioskHardwarePayload = Partial<KioskHardware> & { id: string };

export interface UpdateKioskHardwareRequest {
  type: typeof types.UPDATE_KIOSK_HARDWARE.REQUEST;
  payload: UpdateKioskHardwarePayload;
}

export interface UpdateKioskHardwareError {
  type: typeof types.UPDATE_KIOSK_HARDWARE.ERROR;
  payload: string;
}

export interface UpdateKioskHardwarePending {
  type: typeof types.UPDATE_KIOSK_HARDWARE.PENDING;
  payload: boolean;
}

export interface UpdateKioskHardwareSuccess {
  type: typeof types.UPDATE_KIOSK_HARDWARE.SUCCESS;
  payload: KioskHardware;
}

export interface CreateKioskHardwareRequest {
  type: typeof types.CREATE_KIOSK_HARDWARE.REQUEST;
  payload: CreateKioskHardwarePayload;
}

export interface CreateKioskHardwareError {
  type: typeof types.CREATE_KIOSK_HARDWARE.ERROR;
  payload: string;
}

export interface CreateKioskHardwarePending {
  type: typeof types.CREATE_KIOSK_HARDWARE.PENDING;
  payload: boolean;
}

export interface CreateKioskHardwareSuccess {
  type: typeof types.CREATE_KIOSK_HARDWARE.SUCCESS;
}

export interface DeleteKioskHardwareRequest {
  type: typeof types.DELETE_KIOSK_HARDWARE.REQUEST;
  payload: { id: string; kioskId: string };
}

export interface DeleteKioskHardwareError {
  type: typeof types.DELETE_KIOSK_HARDWARE.ERROR;
  payload: string;
}

export interface DeleteKioskHardwarePending {
  type: typeof types.DELETE_KIOSK_HARDWARE.PENDING;
  payload: boolean;
}

export interface DeleteKioskHardwareSuccess {
  type: typeof types.DELETE_KIOSK_HARDWARE.SUCCESS;
}

export type KioskHardwareActionTypes =
  | ResetKioskHardware
  | GetKioskHardwareRequest
  | GetKioskHardwareSuccess
  | GetKioskHardwareError
  | GetKioskHardwarePending
  | UpdateKioskHardwareRequest
  | UpdateKioskHardwareSuccess
  | UpdateKioskHardwareError
  | UpdateKioskHardwarePending
  | CreateKioskHardwareRequest
  | CreateKioskHardwareSuccess
  | CreateKioskHardwareError
  | CreateKioskHardwarePending
  | DeleteKioskHardwareRequest
  | DeleteKioskHardwareSuccess
  | DeleteKioskHardwareError
  | DeleteKioskHardwarePending;
